import { createSlice } from "@reduxjs/toolkit";
import { api } from "utils";
import { batch } from "react-redux";

const initialState = {
  seqPartner: 0, // 선택된 가맹점 고유번호
  seqPartnerBranch: 0, // 선택된 지점 고유번호
  beforeSeqPartner: 0, // 이전 선택된 가맹점 고유번호
  beforeSeqPartnerBranch: 0, // 이전 선택된 지점 고유번호
  branchUseYn: "N", // 선택된 지점 사용 여부
  headquarterYn: "N", // 선택된 본점 여부
  partnerName: "", // 선택된 가맹점명
  branchName: "", // 선택된 지점명

  mainSeqPartner: 0, // 주 연동센터 가맹점 고유번호
  mainSeqPartnerBranch: 0, // 주 연동센터 지점 고유번호

  partnerList: [], // 연동 센터 목록
  branchList: [], // 지점 목록
  coachList: [], // 강사 목록
  isOneBranch: false, // 단일 연동 센터 여부
  isLoading: false, // 로딩 여부
  isError: false, // 오류 여부
  isNoPartner: false, // 연동 센터 설정 여부
};

const partner = createSlice({
  name: "partner",
  initialState,
  reducers: {
    fetchPartnerInfo: (state, action) => {
      state = Object.assign(state, action.payload);
    },
    fetchReset: () => initialState,
  },
});

export const { fetchPartnerInfo, fetchReset } = partner.actions;

export const updateCoachList = () => async (dispatch, getState) => {
  const partnerInfo = getState().partner;
  const seqPartner = partnerInfo.seqPartner || 0;
  const seqPartnerBranch = partnerInfo.seqPartnerBranch || 0;
  const coachList =
    (await api
      .get(`/coaches/${seqPartner}/${seqPartnerBranch}`)
      .then((response) => {
        return response.data;
      })) || [];
  dispatch(
    fetchPartnerInfo({
      coachList: coachList,
    })
  );
};

export const updateBranchList = () => async (dispatch, getState) => {
  const partnerInfo = getState().partner;
  const seqPartner = partnerInfo.seqPartner || 0;
  const branchList =
    (await api
      .get(`/partnerbranch/partner-branch-list?seqPartner=${seqPartner}`)
      .then(({ data }) => {
        return (data || {}).partnerBranchList || [];
      })) || [];
  dispatch(
    fetchPartnerInfo({
      branchList: branchList,
    })
  );
};

export const updatePartnerInfo = () => async (dispatch, getState) => {
  /**
   * 주 연동 센터가 있는 경우 디폴트값을 주 연동 센터로 설정한다.
   * 만약 주 연동 센터가 없거나 유효하지 않는 경우
   * 연동 지점 목록 중 첫번째 가맹점을 선택하고,
   * 만약 지점형인 경우 첫번째 지점을 선택한다.
   */
  const getDefaultPartnerInfo = (data) => {
    const getPartnerInfo = (seqPartner, seqPartnerBranch) => {
      const result = {};
      result.isOneBranch =
        partnerList.length == 1 &&
        (partnerList[0].partnerBranches || []).length == 1;

      const partnerInfo = partnerList.filter((item) => {
        return item.seqPartner == seqPartner;
      })[0];

      if (partnerInfo) {
        result.seqPartner = partnerInfo.seqPartner || 0;
        result.branchUseYn = partnerInfo.branchUseYn || "N";
        result.headquarterYn =
          partnerInfo.branchUseYn == "Y"
            ? partnerInfo.headOfficeManagerYn || "N"
            : "N";
        result.partnerName = partnerInfo.partnerName || "";
        if (partnerInfo.branchUseYn == "Y") {
          const branchInfo = (partnerInfo.partnerBranches || []).filter(
            (item) => {
              return item.seqPartnerBranch == seqPartnerBranch;
            }
          )[0];
          if (branchInfo) {
            result.seqPartnerBranch = branchInfo.seqPartnerBranch || 0;
            result.branchName = branchInfo.partnerName || "";
          }
        }
      }
      // result.seqPartner && (result.branchUseYn == "N" || (result.branchUseYn == "Y" && result.seqPartnerBranch))
      if (result.seqPartner) {
        return result;
      }
    };

    const mainPartnerInfo = data.mainPartner;
    const partnerList = data.partners || [];
    if (data.mainPartner) {
      const seqPartner = data.mainPartner.seqPartner;
      const seqPartnerBranch = data.mainPartner.seqPartnerBranch;
      const result = getPartnerInfo(seqPartner, seqPartnerBranch);
      if (result) {
        result.mainSeqPartner = seqPartner;
        result.mainSeqPartnerBranch = seqPartnerBranch;
        return result;
      }
    }
    const partnerInfo = partnerList[0] || {};
    const seqPartner = partnerInfo.seqPartner || 0;
    const seqPartnerBranch =
      partnerInfo.branchUseYn == "Y"
        ? (partnerInfo.partnerBranches || [])[0].seqPartnerBranch || 0
        : 0;
    const result = getPartnerInfo(seqPartner, seqPartnerBranch);
    if (result) return result;
    return result;
  };

  const partnerInfo = getState().partner;
  if (partnerInfo.isLoading) {
    console.log("loading..");
    return;
  }

  try {
    dispatch(fetchReset());
    dispatch(
      fetchPartnerInfo({
        isLoading: true,
        isNoPartner: false,
      })
    );
    // const seqManagerMobile = 100000;
    await api.post("/interlock/partner").then(({ data }) => {
      const defaultPartnerInfo = getDefaultPartnerInfo(data);
      const isNoPartner = !(data.partners || []).length;

      if (!defaultPartnerInfo) {
        dispatch(
          fetchPartnerInfo({
            isNoPartner: isNoPartner,
            isError: true,
          })
        );
      } else {
        batch(() => {
          dispatch(
            fetchPartnerInfo(
              Object.assign(
                {
                  partnerList: data.partners || [],
                  isNoPartner: isNoPartner,
                },
                defaultPartnerInfo
              )
            )
          );
          // dispatch(updateBranchList());
        });
      }
    });
  } catch (error) {
    console.error(error);
    dispatch(
      fetchPartnerInfo({
        isNoPartner: true,
        isError: true,
      })
    );
  } finally {
    dispatch(
      fetchPartnerInfo({
        isLoading: false,
      })
    );
  }
};

export default partner.reducer;
